import { useCallback } from 'react'

import { useFilters } from '../../../../../../../shared/hooks'
import { PROMO_BANNERS_ID_DEFAULT_FILTERS } from '../../constants/filters'
import { PromoBannersIdFiltersType } from '../../containers/PromoBannersIdFiltersForm/PromoLandingsFiltersForm.types'
import { preparePromoBannerIdFiltersInput } from '../../utils/preparePromoBannerIdFiltersInput'

import { useBannerFiltersLocalStorageKeyWithUserId } from '../useBannerFiltersLocalStorageKeyWithUserId'

export const useBannersIdFilters = (id: string) => {
  const { filters, onFiltersChange } = useFilters<PromoBannersIdFiltersType>({
    addedToSaveFiltersKeys: ['locales', 'imageSizes', 'fileFormats'],
    defaultFilterList: PROMO_BANNERS_ID_DEFAULT_FILTERS,
    filtersLocalStorageKey: useBannerFiltersLocalStorageKeyWithUserId(id),
    prepareFiltersInput: preparePromoBannerIdFiltersInput,
  })

  const handleFiltersChange = useCallback(
    (values: PromoBannersIdFiltersType) => {
      onFiltersChange({
        ...filters,
        ...values,
      })
    },
    [filters, onFiltersChange],
  )

  return {
    filters,
    handleFiltersChange,
  }
}
